import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import * as React from 'react';
import { cn } from 'utils/cn';

interface HoverCardProps
  extends React.ComponentProps<typeof HoverCardPrimitive.Root> { }

interface HoverCardComponentType extends React.FC<HoverCardProps> {
  Trigger: typeof HoverCardTrigger;
  Content: typeof HoverCardContent;
  Arrow: typeof HoverCardArrow;
}

const HoverCardArrow: React.FC<
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Arrow>
> = ({ className, ...props }) => (
  <HoverCardPrimitive.Arrow {...props} className={className} />
);

const HoverCard: HoverCardComponentType = ({ children, ...props }) => (
  <HoverCardPrimitive.Root {...props}>{children}</HoverCardPrimitive.Root>
);

HoverCard.displayName = 'HoverCard';

const HoverCardTrigger: React.FC<
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Trigger>
> = (props) => <HoverCardPrimitive.Trigger {...props} />;

HoverCardTrigger.displayName = 'HoverCard.Trigger';

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <HoverCardPrimitive.Content
    ref={ref}
    align={align}
    sideOffset={sideOffset}
    className={cn(
      'origin-[var(--radix-hover-card-content-transform-origin)]',
      'text-popover-foreground bg-popover data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-64 rounded-lg border border-border p-4 shadow-md outline-none',
      className
    )}
    {...props}
  />
));

HoverCardContent.displayName = 'HoverCard.Content';

HoverCard.Trigger = HoverCardTrigger;
HoverCard.Content = HoverCardContent;
HoverCard.Arrow = HoverCardArrow;

export default HoverCard;
